import LoginBox from './index.vue'

LoginBox.install = function (Vue) {
  Vue.component(LoginBox.name, LoginBox)
}

export default LoginBox
